module.exports = __webpack_public_path__ + "img/logo_TW.05dfbaaa.png";